import {
    Dashboard, Branch, Role, User,
    // SkillCategory, InterviewProcess,
    VendorCompany, VendorContactPerson,
    SalesMyRequirement,
    // Candidate,
    RecruiterMyRequirement,
    Pipeline,
    ECI,
    PO,
} from "../components";

type RG = 'Dashboard' | 'Requirement' | 'Reports' | 'Settings';
enum AppRouteGroupIcon {
    Dashboard = 'pi-home',
    Settings = 'pi-cog',
    Reports = 'pi-chart-bar',
    Requirement = 'pi-briefcase',
    Pipeline = 'pi-users',
    ECI = 'pi-id-card',
    PO = 'pi-file',
}
export function getGroupIcon(g: string) {
    switch (g) {
        case 'Dashboard':
            return AppRouteGroupIcon.Dashboard;
        case 'Settings':
            return AppRouteGroupIcon.Settings;
        case 'Reports':
            return AppRouteGroupIcon.Reports;
        case 'Requirement':
            return AppRouteGroupIcon.Requirement;
        case 'Pipeline':
            return AppRouteGroupIcon.Pipeline;
        case 'ECI':
            return AppRouteGroupIcon.ECI;
        case 'PO':
            return AppRouteGroupIcon.PO;
        default:
            return 'pi-folder';
    }
}

type AppRoute = {
    path: string;
    label: string;
    element: JSX.Element;
    group?: RG;
    icon?: string;
};

export const appRoutes: AppRoute[] = [
    { path: '/dashboard', label: 'Dashboard', element: <Dashboard /> },
    { path: '/branch', label: 'Branch', element: <Branch />, group: 'Settings' },
    { path: '/user', label: 'User', element: <User />, group: 'Settings' },
    { path: '/role', label: 'Role', element: <Role />, group: 'Settings' },
    // { path: '/interview-process', label: 'Interview Process', element: <InterviewProcess />, group: 'Requirement' },
    // { path: '/skill-category', label: 'Skill Category', element: <SkillCategory />, group: 'Requirement' },
    { path: '/sales-my-requirement', label: 'My Requirement (Sales)', element: <SalesMyRequirement />, group: 'Requirement' },
    { path: '/recruiter-my-requirement', label: 'My Requirement (Recruiter)', element: <RecruiterMyRequirement />, group: 'Requirement' },
    { path: '/vendor-contact-person', label: 'Vendor Contact', element: <VendorContactPerson />, group: 'Requirement' },
    { path: '/vendor-company', label: 'Vendor Company', element: <VendorCompany />, group: 'Requirement' },
    { path: '/pipeline', label: 'Pipeline', element: <Pipeline /> },
    { path: '/eci', label: 'ECI', element: <ECI /> },
    { path: '/po', label: 'PO', element: <PO /> },
];
